var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("bussinesscooperator.title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("bussinesscooperator.content")))]),_c('viewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }